var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"title"},[_vm._v(" Danghuan ")]),_c('div',{staticClass:"fail"},[_c('img',{staticClass:"fail-logo",attrs:{"src":require("../../assets/image/upload/5.png"),"alt":""}}),_c('span',[_vm._v("网络错误，请刷新页面")])])])
}]

export { render, staticRenderFns }